<!--
  ~ Copyright (c) 2019
  ~    Reliant Business Valuation, LLC - http://reliantvalue.com
  ~    Author: Kirill Vizniuk - kirill@internalvaluation.com
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && onSubmit()" novalidate>

  <!-- Alert Message -->
  <crm-alert #alert></crm-alert>

  <!-- Bank -->
  <div class="form-group">
    <label>Bank</label>
    <input-search placeholder="Search by Name" [name]="CLIENT" [(ngModel)]="clientUser.CLIENT" #CLIENT="ngModel" (valueChange)="searchClient($event)"
      [inputValue]="clientUser.CLIENT" [provider]="clientProvider" [disabled]="isLender && !isOther"></input-search>
      <small *ngIf="f.submitted && CLIENT.invalid" class="form-text text-danger">Bank is required</small>
  </div>

  <!-- First Name -->
  <div class="form-group">
    <label>Name</label>
    <input type="text" name="NAME" class="form-control rounded-0" [(ngModel)]="clientUser.NAME" #NAME="ngModel"
           [ngClass]="{'is-invalid': f.submitted && NAME.invalid }" required [maxlength]="100">
    <div *ngIf="f.submitted && NAME.invalid" class="invalid-feedback">
			<div *ngIf="NAME.errors.required">Name is required</div>
		</div>
  </div>

 <!--  <div class="form-group">
    <label>Last Name</label>
    <input type="text" name="LAST_NAME" class="form-control rounded-0" [(ngModel)]="clientUser.LAST_NAME" #LAST_NAME="ngModel"
           [ngClass]="{'is-invalid': f.submitted && LAST_NAME.invalid }" [maxlength]="100">
    <div *ngIf="f.submitted && LAST_NAME.invalid" class="invalid-feedback">
			<div *ngIf="LAST_NAME.errors.required">Lastname is required</div>
		</div>
  </div> -->

  <!-- Title -->
  <div class="form-group">
    <label>Title</label>
    <input type="text" name="TITLE" [(ngModel)]="clientUser.TITLE" #ADDRESS="ngModel" class="form-control rounded-0"
      maxlength="100">
  </div>

  <!-- LinkedIn URL -->
  <div class="form-group">
    <label>LinkedIn Url</label>
    <input type="text" name="LINKEDIN_URL" [(ngModel)]="clientUser.LINKEDIN_URL" #ADDRESS="ngModel"
      class="form-control rounded-0" maxlength="200">
  </div>

  <!-- Address -->
  <div class="form-group">
    <label>Address</label>
    <input type="text" name="ADDRESS" [(ngModel)]="clientUser.ADDRESS" #ADDRESS="ngModel" class="form-control rounded-0"
      [ngClass]="{'is-invalid': f.submitted && ADDRESS.invalid }" [maxlength]="100">

    <div *ngIf="f.submitted && ADDRESS.invalid" class="invalid-feedback">
      <div *ngIf="ADDRESS.errors.required">Address is required</div>
    </div>
  </div>

  <!-- Address2 -->
  <div class="form-group">
    <label>Address2</label>
    <input type="text" name="ADDRESS2" [(ngModel)]="clientUser.ADDRESS2" class="form-control rounded-0"
      [maxlength]="100">
  </div>

  <!-- Eng Address -->
  <div class="form-group">
    <div style="display: flex; justify-content: space-between; align-items: flex-end;">
      <label>Eng Address</label>

       <div class="checkbox-item">
        <input class="checkbox-custom" type='checkbox' name="ENG_ADDRESS_USE_FILE" id="engAddressOnFile" [(ngModel)]="clientUser.ENG_ADDRESS_USE_FILE"
          [checked]="clientUser.ENG_ADDRESS_USE_FILE === true" (ngModelChange)="engAddressChanged($event)" />
        <label class="checkbox-custom-label" for="engAddressOnFile">Use Bank Address on the File</label>
      </div>
    </div>

    <input type="text" name="ENG_ADDRESS" [disabled]="clientUser.ENG_ADDRESS_USE_FILE"
      [(ngModel)]="clientUser.ENG_ADDRESS" class="form-control rounded-0" [maxlength]="100">
  </div>

  <!-- Zip + State -->
  <div class="form-row">
    <!-- Zip -->
    <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <label>Zip</label>
      <input type="text" maxlength="5" [(ngModel)]="clientUser.ZIP" name="ZIP" class="form-control rounded-0"
        #ZIP="ngModel" (keyup)="zipKeyUp()" (keypress)="zipKeyPress($event)" [ngClass]="{'is-invalid': f.submitted && ZIP.invalid}">
      <div *ngIf="zipError" class="invalid-feedback">
        {{zipError}}
      </div>

       <div *ngIf="f.submitted && ZIP.invalid" class="invalid-feedback">
         <div *ngIf="ZIP.errors.required">Zip is required</div>
       </div>
    </div>

    <!-- State -->
    <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <label>State</label>
      <input-search [preset]="stateItems" name="STATE" [(ngModel)]="clientUser.STATE" [regular]="true" [searchable]="true"
        #STATE="ngModel" [invalid]="f.submitted && STATE.invalid"
        (valueChange)="processPresetValue($event)" placeholder="Select State"></input-search>
        <small *ngIf="f.submitted && STATE.invalid" class="form-text text-danger">State is required</small>
    </div>
  </div>

  <!-- City -->
  <div class="form-group">
     <label>City</label>
     <input type="text" name="CITY" [(ngModel)]="clientUser.CITY" class="form-control rounded-0" #CITY="ngModel"
       [ngClass]="{'is-invalid': f.submitted && CITY.invalid}" [maxlength]="100">

    <div *ngIf="f.submitted && CITY.invalid" class="invalid-feedback">
      <div *ngIf="CITY.errors.required">City is required</div>
    </div>
  </div>

  <!-- Phone Business -->
  <div class="form-row">
    <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <label>Phone Business</label>
      <input type="text" name="PHONE_OFFICE" [(ngModel)]="clientUser.PHONE_OFFICE" numbers
        (input)="maskPhoneNumber($event, clientUser.PHONE_OFFICE)"
        class="form-control rounded-0" placeholder="(000)-000-0000">
    </div>

    <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <label>Phone Ext</label>
        <input type="text" name="PHONE_EXT" [(ngModel)]="clientUser.PHONE_EXT" numbersOnly maxlength="5" class="form-control rounded-0" placeholder="000">
    </div>
  </div>


  <div class="form-row">
    <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <label>Phone Personal</label>
      <input type="text" name="PHONE_PERSONAL" [(ngModel)]="clientUser.PHONE_PERSONAL" numbers
        (input)="maskPhoneNumber($event, clientUser.PHONE_PERSONAL)"
        class="form-control rounded-0" placeholder="(000)-000-0000">
    </div>

    <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <label>Phone</label>
      <input type="text" name="PHONE_MOBILE" [(ngModel)]="clientUser.PHONE_MOBILE" numbers
      (input)="maskPhoneNumber($event, clientUser.PHONE_MOBILE)"
        class="form-control rounded-0" placeholder="(000)-000-0000">
    </div>
  </div>

  <!-- Phone + Fax -->
  <div class="form-row">
    <div class="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <label>Fax</label>
      <input type="text" name="PHONE_FAX" [(ngModel)]="clientUser.PHONE_FAX" numbers
        (input)="maskPhoneNumber($event, clientUser.PHONE_FAX)"
        class="form-control rounded-0" placeholder="(000)-000-0000">
    </div>
  </div>

  <!-- Email -->
  <div class="form-group">
    <label>Email</label>
    <input type="email" name="EMAIL" class="form-control rounded-0" [(ngModel)]="clientUser.EMAIL" #EMAIL="ngModel"
           [ngClass]="{ 'is-invalid': f.submitted && EMAIL.invalid }" [maxlength]="60">
    <div *ngIf="f.submitted && EMAIL.invalid" class="invalid-feedback">
			<div *ngIf="EMAIL.errors.required">Email is required</div>
		</div>
  </div>

  <!-- Notes -->
  <div class="form-group">
    <label>Notes</label>
    <textarea name="NOTES" [(ngModel)]="clientUser.NOTES" class="form-control rounded-0" rows="3"
    [maxlength]="100"></textarea>
  </div>

  <!-- Submit Button -->
  <div class="actions horizontal wrap right">
    <button type="button" class="btn btn-rbv default" (click)="actionCancel()">Cancel</button>
    <button type="submit" class="btn btn-rbv">Submit</button>
  </div>

</form>
